export default __webpack_public_path__ + "static/media/common_Datepicker_MonthArrow.d2fa5ce2.svg";